import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import {
  Stack,
} from "@mui/material";


export default function EmailResendConfirmation(props) {
  const { open, sendItem, modelPopUpYesNoFunc, title, bodyMessage } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
     
      <Dialog
        className="user-filter-popup user-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        //onClose={""}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "26px 34px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">{ title }</Typography>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          <p className="label"> { bodyMessage } </p>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 34px", mt: "21px" }}
        >
          <Button className="filter-btn" onClick={()=>{ modelPopUpYesNoFunc(sendItem);}}>
            Yes
          </Button>
          <Button className="cancel-btn" onClick={modelPopUpYesNoFunc}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
